var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
var LotteryFaq = /** @class */ (function (_super) {
    __extends(LotteryFaq, _super);
    function LotteryFaq(notificationService, i18N) {
        return _super.call(this, notificationService, i18N) || this;
    }
    LotteryFaq.prototype.onActivated = function (item) {
        this._lotteryId = item.lotteryId;
        if (item.navigationInfo && item.navigationInfo.brandId) {
            this.lotteryAdditionalInfo = item.brandLotteries[0].lotteryAdditionalInfo;
        }
        else {
            //if the lottery doesn't have an faq we need to create it
            if (!item.lotteryAdditionalInfo) {
                item.lotteryAdditionalInfo = {
                    faq: "",
                    lotteryAdditionalInfoId: 0
                };
            }
            this.lotteryAdditionalInfo = item.lotteryAdditionalInfo;
        }
    };
    LotteryFaq = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N])
    ], LotteryFaq);
    return LotteryFaq;
}(ChildComponent));
export { LotteryFaq };
